var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobbliReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 100,
    viewBox: "0 0 111 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_129_4",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 0H0V100H111V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_129_4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_129_4",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111 0H0V100H111V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_129_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.297 44.7671C110.297 75.2669 85.7606 100 55.5012 100C25.2421 100 0.704956 75.2669 0.704956 44.7671C0.704956 38.6683 5.61355 33.7206 11.6642 33.7206C17.7148 33.7206 22.6234 38.6683 22.6234 44.7671C22.6234 63.0695 37.3435 77.9064 55.5012 77.9064C73.6588 77.9064 88.3794 63.0695 88.3794 44.7671C88.3794 38.6683 93.2874 33.7206 99.338 33.7206C105.389 33.7206 110.297 38.6683 110.297 44.7671Z",
    fill: "#10101B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3393 23.5112C105.781 23.5112 111.002 18.248 111.002 11.7555C111.002 5.26289 105.781 -0.000366211 99.3393 -0.000366211C92.8978 -0.000366211 87.6765 5.26289 87.6765 11.7555C87.6765 18.248 92.8978 23.5112 99.3393 23.5112Z",
    fill: "#10101B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.663 23.5109C18.1042 23.5109 23.3259 18.2476 23.3259 11.7551C23.3259 5.26252 18.1042 -0.000732422 11.663 -0.000732422C5.22169 -0.000732422 0 5.26252 0 11.7551C0 18.2476 5.22169 23.5109 11.663 23.5109Z",
    fill: "#10101B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobbliReport);
export default __webpack_public_path__ + "static/media/jobbli-report.2447a5f206705eee7fb8a895fe7f9560.svg";
export { ForwardRef as ReactComponent };